import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DailygridsColumns } from 'src/app/shared/model/dailygrids-column';
import { Feed } from 'src/app/shared/model/feed';
import { FeedDailyColumns } from 'src/app/shared/model/feed-daily-columns';
import { FeedService } from 'src/app/shared/service/feed.service';

@Component({
  selector: 'app-configuration-dailygrids-columns',
  templateUrl: './configuration-dailygrids-columns.component.html',
  styleUrls: ['./configuration-dailygrids-columns.component.css']
})
export class ConfigurationDailygridsColumnsComponent implements OnInit {


  feeds: FeedDailyColumns[] = [];
  columns: DailygridsColumns[] = [];
  selectedFeed: FeedDailyColumns | null = null;
  assignedColumns: DailygridsColumns[] = [];
  unassignedColumns: DailygridsColumns[] = [];
  isLoadingFeed: boolean;
  submitted: boolean;

  allUnassignedSelected: boolean = false;


  constructor(private feedService: FeedService,
    private snackBar: MatSnackBar,
    private translate: TranslateService


  ) { }

  ngOnInit(): void {
    this.isLoadingFeed = true;
    this.loadFeeds();
    this.loadAllColumns();
    this.submitted= false;
  }

  loadFeeds(): void {
    this.feedService.getFeedsAndDailyColumns().subscribe(
      (response) => {
        this.feeds = response;
        this.isLoadingFeed = false;
        console.log('Feeds cargados:', this.feeds);
      },
      (error) => {
        console.log("Error al cargar los feeds")
        this.isLoadingFeed = false;

      }
    );
  }

  loadAllColumns(): void {
    this.feedService.getAllDailygridsColumns().subscribe(
      (response) => {
        this.columns = response;
        console.log('Columnas cargadas:', this.columns);

      },
      (error) => {
        console.log("Error al cargar las columnas")

      }
    );
  }

  onFeedSelect(feed: FeedDailyColumns): void {
    if (feed) {
      this.selectedFeed = feed;
      console.log("feed seleccionado: " + this.selectedFeed.code);

      this.assignedColumns = this.selectedFeed.dailygridsColumns || [];
      console.log("columnas del feed: ", this.selectedFeed.dailygridsColumns);

      // this.assignedColumns = [...assignedColumns];

      this.unassignedColumns = this.columns.filter(
        (col) => !this.assignedColumns.some((assigned) => assigned.id === col.id)
      );

      this.allUnassignedSelected = false;

    }
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }



  saveChanges(): void {
    this.submitted = true;
    if (this.selectedFeed) {
      const feedAndColumns: FeedDailyColumns = {
        ...this.selectedFeed,
        dailygridsColumns: [...this.assignedColumns],
      };

      this.feedService.setDailygridsColumnsForFeed(feedAndColumns).subscribe(
        (response) =>{
          this.translate.get("epg.configurationDailyColumns.snackbarSuccess").subscribe((message) => {
            this.snackBar.open(message, "X", {
              duration: 3000,
              panelClass: ["SuccessfulSnackbar"],
            });
          });
          this.submitted = false;

          console.log('Cambios guardados correctamente:', response);
        },
        (error) => {
          this.submitted = false;
          console.error('Error al guardar los cambios:', error);
          this.translate.get("epg.configurationDailyColumns.snackbarError").subscribe((message) => {
            this.snackBar.open(message, "X", {
              duration: 3000,
              panelClass: ["error-snackbar"],

            });
          });

        }
      );
    } else {
      console.warn('No hay un feed seleccionado para guardar los cambios.');
    }
  }

  activeSection: number = 1; // Por defecto, activamos la primera sección

  // Método para cambiar la sección activa
  changeSection(section: number): void {
    this.activeSection = section;
  }

  // Método para verificar si una sección está activa
  isActiveSection(section: number): boolean {
    return this.activeSection === section;
  }

   moveAllToAssigned(checked: boolean): void {
    if (checked) {
      this.assignedColumns.push(...this.unassignedColumns);
      this.unassignedColumns = [];
    } else {
      this.unassignedColumns.push(...this.assignedColumns);
      this.assignedColumns = [];
    }
  }


}



